import React from 'react';
import {observable} from "mobx";

class Store {
  @observable showItemId = 'cjwt';
}

export default new Store()
